export enum UASSIST_STATUS {
    COMPLETED = "COMPLETED",
    IN_PROGRESS = "IN_PROGRESS",
    REFINEMENT_READY = "REFINEMENT_READY",
    READY = "READY",
    NO_UASSIST = "NO_UASSIST"
}
